import type { SVGProps } from 'react';

export function DeskWork({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* desk */}
      <rect x="40" y="260" width="320" height="12" />
      <line x1="60" y1="272" x2="60" y2="360" />
      <line x1="340" y1="272" x2="340" y2="360" />

      {/* monitor */}
      <rect x="110" y="120" width="180" height="120" rx="4" />
      <line x1="180" y1="240" x2="220" y2="240" />
      <line x1="200" y1="240" x2="200" y2="260" />

      {/* screen grid (accent) */}
      <g stroke="#E7FF4D" strokeWidth="1.5">
        <line x1="130" y1="145" x2="270" y2="145" />
        <line x1="130" y1="170" x2="220" y2="170" />
        <rect x="130" y="185" width="60" height="40" rx="2" />
        <rect x="200" y="185" width="70" height="40" rx="2" />
      </g>

      {/* mug */}
      <rect x="310" y="225" width="30" height="35" rx="2" />
      <path d="M340 232 h8 a6 6 0 0 1 0 12 h-8" />
      <path d="M318 220 c0 -6 4 -10 0 -14" stroke="#E7FF4D" strokeWidth="1.5" />

      {/* notebook */}
      <rect x="60" y="235" width="60" height="30" rx="2" />
      <line x1="70" y1="245" x2="110" y2="245" />
      <line x1="70" y1="255" x2="100" y2="255" />

      {/* chair back */}
      <path d="M200 360 v30" />
      <path d="M170 380 h60" />

      {/* plant */}
      <rect x="340" y="190" width="30" height="30" />
      <path d="M355 190 c -10 -25 -5 -45 0 -55" stroke="#E7FF4D" />
      <path d="M355 190 c 10 -20 15 -35 10 -50" stroke="#E7FF4D" />
      <path d="M355 190 c -5 -15 -15 -25 -20 -30" stroke="#E7FF4D" />
    </svg>
  );
}
